var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35707 3C4.40145 3 2 5.43001 2 8.35707C2 9.37974 2.46277 10.2634 2.89126 10.9033C3.32165 11.5431 3.76157 11.9526 3.76157 11.9526L11.4877 19.6997L12 20.2139L12.5142 19.6997L20.2403 11.9526C20.2403 11.9526 22 10.3986 22 8.35707C22 5.43001 19.6005 3 16.6448 3C14.192 3 12.6113 4.47591 12 5.09865C11.3887 4.47591 9.80994 3 7.35707 3Z",
    fill: "#D8D8D8",
    fillOpacity: 0.7,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfavIcon);
export default __webpack_public_path__ + "static/media/unfavIcon.ee1fd14ae1a64b35026fe93e41a835dc.svg";
export { ForwardRef as ReactComponent };